/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { Platform } from 'cio/utils/push/platforms';
import AuthService from 'cio/services/auth';

interface SendTestRecipientSignature {
  Element: HTMLDivElement;
  Args: {
    disabled: boolean;
    isRecipientReadOnly: boolean;
    hasMultiplePlatforms: boolean;
    platform: Platform;
    recipient: string;
    placeholder?: string;
    recipientErrors: string[];
    showErrorMessage: boolean;
    type: string;
    onPushPlatformSelect: (platform: Platform) => unknown;
    onRecipientInput: (recipient: string | null) => unknown;
  };
}

export default class SendTestRecipient extends Component<SendTestRecipientSignature> {
  @service auth!: AuthService;

  @tracked pushPlatforms!: Record<string, any>[];

  get hasError() {
    return this.args.recipientErrors?.length > 0;
  }

  constructor(owner: unknown, args: SendTestRecipientSignature['Args']) {
    super(owner, args);

    if (this.args.type === 'push') {
      this.pushPlatforms = [
        {
          value: 'android',
          label: 'Android',
        },
        {
          value: 'ios',
          label: 'iOS',
        },
      ];
    }
  }

  @action
  onPushPlatformSelect(selectedItem: Record<string, any>) {
    this.args.onPushPlatformSelect(selectedItem.value as Platform);
  }
}
